import React from 'react'
import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'

const colorByType = (props: any, disable?: boolean): any => {
  return {
    blue: {
      backgroundColor: disable ? props.theme.color.whitesmoke : props.theme.color.dodgerblue,
      borderColor: 'none',
      textColor: disable ? props.theme.color.linkwater : props.theme.color.white,
      hoverStyles: `
        background: linear-gradient(329.85deg, ${props.theme.color.goldenyellow} 6.75%, ${props.theme.color.dodgerblue} 91.35%);
      `,
      padding: '12px 40px'
    },
    transparent: {
      backgroundColor: props.theme.color.white,
      borderColor: `1px solid ${disable ? props.theme.color.linkwater : props.theme.color.dodgerblue}`,
      textColor: disable ? props.theme.color.linkwater : props.theme.color.dodgerblue,
      hoverStyles: `
        border: double 1px transparent;
        background-image: linear-gradient(${props.theme.color.white}, ${props.theme.color.white}),
          radial-gradient(circle at bottom right, ${props.theme.color.goldenyellow}, ${props.theme.color.dodgerblue});
        background-origin: border-box;
        background-clip: content-box, border-box;
      `,
      padding: '12px 40px'
    },
    'transparent-grey': {
      backgroundColor: props.theme.color.whitesmoke,
      borderColor: `1px solid ${disable ? props.theme.color.linkwater : props.theme.color.dodgerblue}`,
      textColor: disable ? props.theme.color.linkwater : props.theme.color.dodgerblue,
      hoverStyles: `
        border: double 1px transparent;
        background-image: linear-gradient(${props.theme.color.whitesmoke}, ${props.theme.color.whitesmoke}),
          radial-gradient(circle at bottom right, ${props.theme.color.goldenyellow}, ${props.theme.color.dodgerblue});
        background-origin: border-box;
        background-clip: content-box, border-box;
      `,
      padding: '12px 40px'
    },
    red: {
      backgroundColor: 'transparent',
      borderColor: 'none',
      textColor: props.theme.color.radicalred,
      padding: 0,
      hoverStyles: `
      `
    }
  }
}

export const getButtonStyles = (color: 'blue' | 'transparent' | 'transparent-grey' | 'red', disable?: boolean): any => css`
  background-color: ${props => colorByType(props, disable)[color].backgroundColor};
  border: ${props => colorByType(props, disable)[color].borderColor};
  color: ${props => colorByType(props, disable)[color].textColor};
  ${props => color === 'red' ? props.theme.typography.p2 : props.theme.typography.p1};
  box-sizing: border-box;
  border-radius: 24px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  cursor: pointer;
  ${disable ? 'pointer-events: none' : ''};
  &:hover {
    ${props => disable ? 'pointer-events: none' : colorByType(props)[color].hoverStyles}
  }
  &.noWrap {
    > div {
      white-space: nowrap;
    }
  }
`

const InnerDiv = styled.div<{ color: 'blue' | 'transparent' | 'transparent-grey' | 'red' }>`
  width: 100%;
  padding: ${(props) => (props.color === 'red' ? 0 : '12px 40px')};
  text-align: center;
  display: flex;
  white-space: nowrap;
  align-items: center;
  justify-content: center;
  gap: 8px;

  @media screen and (max-width: ${({ theme }) => theme.resolution.sm}) {
    padding: ${(props) => (props.color === 'red' ? 0 : '12px 32px')};
  }
`

const ButtonWrapper = styled.button<{ color: 'blue' | 'transparent' | 'transparent-grey' | 'red', $isDisabled?: boolean }>`
  ${({ color, $isDisabled }) => getButtonStyles(color, $isDisabled)}
`

const StyledLink = styled(Link)<{ color: 'blue' | 'transparent' | 'transparent-grey' | 'red', disable?: boolean }>`
  ${({ color, disable }) => getButtonStyles(color, disable)}
`

const StyledExternalLink = styled.a<{ color: 'blue' | 'transparent' | 'transparent-grey' | 'red', disable?: boolean }>`
  ${({ color, disable }) => getButtonStyles(color, disable)}
`
interface ButtonProps {
  onClick?: any
  onMouseEnter?: any
  onMouseLeave?: any
  type?: any
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
  href?: string
  target?: string
  to?: string
  disable?: boolean
  rel?: string
  format: 'blue' | 'transparent' | 'transparent-grey' | 'red'
  state?: any
}

export const Button: React.FC<ButtonProps> = ({
  onClick,
  onMouseEnter,
  onMouseLeave,
  type,
  children,
  className,
  style,
  href,
  target,
  to,
  disable,
  rel,
  format,
  state
}) => {
  const ResultLink = to ? StyledLink : href ? StyledExternalLink : undefined

  return (
    <ButtonWrapper
      color={format}
      type={type}
      style={style}
      className={className}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      target={target}
      {...(to ? { to } : {})}
      {...(href ? { href } : {})}
      as={ResultLink}
      $isDisabled={disable}
      rel={rel}
      state={state}
    >
      <InnerDiv color={format}>{children}</InnerDiv>
    </ButtonWrapper>
  )
}
